document.addEventListener('DOMContentLoaded', function() {
  $('.testimonials-carousel').owlCarousel({
    loop: true,
    margin: 55,
    nav: false,
    dots: false,
    autoplay: false,
    autoplayTimeout: 7000,  // Slide stays longer (7 seconds)
    autoplayHoverPause: true,
    smartSpeed: 1500,  
    responsive: {
      0: {
        items: 1,
        margin: 15
      },
      768: {
        items: 2,
        margin: 20
      },
      1036: {
        items: 2,
        margin: 20
      },
      1440: {
        items: 2,
        margin: 55
      }
    }
  });
  
  $('.feat-prod-slider').owlCarousel({
    loop: true,
    margin: 27,
    nav: false,
    dots: false,
    autoplay: false,
    autoplayTimeout: 7000,  // Slide stays longer (7 seconds)
    autoplayHoverPause: true,
    smartSpeed: 1500,  
    responsive: {
      0: {
        items: 1
      },
       570: {
        items: 2
      },
      768: {
        items: 2
      }, 
      1037: {
        items: 3
      },
      1440: {
        items: 4
      }
    }
  });

   $('.ban-prod-slider').owlCarousel({
    loop: true,
    margin: 21,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 7000,  // Slide stays longer (7 seconds)
    autoplayHoverPause: true,
    smartSpeed: 1500,  
    responsive: {
      0: {
        items: 1.1,
        margin: 15
      },
      768: {
        items: 1.3,
        margin: 15
      }, 
      1037: {
        items: 1.3
      },
      1440: {
        items: 1.3
      }
    }
  });

});


jQuery(document).ready(function($) {
  if (navigator.share) {
  this.mainDetailsToggle.setAttribute('hidden', '');
}
});

